import { useState, useEffect } from "react";

import LoadingScreen from "./components/LoadingScreen";
import Navbar from "./components/Navbar";

import About from "./views/About";
import Home from './views/Home'
import Services from "./views/Experience";
import Contact from "./views/Contact";

import { ThemeProvider } from "./themeProvider";

function App() {
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    setTimeout(() => setLoading(false), 1000)
  }, [])

  return (
    <ThemeProvider>
      <>
        {!loading ? (
          <div >
            <Navbar />
            <Home />
            <About />
            <Services />
            <Contact />
          </div>

        ) : (
          <LoadingScreen />
        )}
      </>
    </ThemeProvider>

  );
}

export default App;
